import {LOAD_DATA, SUCCESS, STORE} from "../../../constants";

export default (tags = [], action) => {
  const {type, response} = action;

  switch (type) {
    case STORE + LOAD_DATA + SUCCESS:
      return response.tags;
  }
  return tags;
};
